/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/naming-convention */
import { Form, Formik } from "formik";
import React, { useState } from "react";
import { useLazyUsuariosDisponiblesQuery, useRecuperarContrasenaMutation } from "src/redux/api/authApi";
import TextInput from "src/components/input/TextInput";
import { Box, Button, Typography, CardContent, Card, Link } from "@mui/material";
import { UsuarioDisponibleResponse } from "src/redux/api/types/auth";
import { toast } from "react-toastify";
import { esquemaDeValidacionLogin, setValoresInicialesForm } from "./utils";

function EnvioCorreoRecuperacion() {
  const [recuperarContrasena, { isSuccess, isLoading: cargandoPeticion }] =
    useRecuperarContrasenaMutation();
  
  const [mostrarSeleccionFacultad, setMostrarSeleccionFacultad] =
  useState(false);
  
  const [obtenerUsuariosDisponibles, { data: usuariosDisponibles, isLoading: cargandoUsuariosDisponibles }] =
  useLazyUsuariosDisponiblesQuery();

  const handleSeleccionUsuario = (usuario : UsuarioDisponibleResponse) => {
    // TODO: Gestionar contrato con BACK
    // if (usuario.tipoUsuario === "INSTITUCIONAL") {
    //   window.open("https://udea.edu.co/wps/portal/udea/web/inicio/obtener-recuperar-usuario-contrasena/");
    //   setMostrarSeleccionFacultad(false);
    //   return;
    // }
    recuperarContrasena({usuariounidadId: usuario.usuariounidadId});
  }

  const onSubmit = (values: any, setSubmitting: any) => {
    obtenerUsuariosDisponibles(values.nombreUsuarioCorreoDocumento)
      .unwrap()
      .then((resp) => {
        if (resp.length === 0) {
          toast.error("Usuario no encontrado en el sistema");
          return;
        }
        if (resp.length === 1) {
          handleSeleccionUsuario(resp[0]);
          return;
        }
        setMostrarSeleccionFacultad(true);
      });
    setSubmitting(false);
  };

  if (isSuccess) {
    return (
      <Box
        sx={{
          width: "50%",
          minHeight: "100%",
          height:"100vh",
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          paddingLeft: { xs: 0, md: 3 },
        }}
        data-testid="registro-exitoso"
      >
        <Card
          variant="elevation"
          sx={{
            minWidth: "350px",
            padding: 3,
            marginY: 3,
            marginX: { xs: 2, md: 0 },
          }}
        >
          <CardContent>
            <Typography variant="h5" component="div" gutterBottom align="left">
            Recuperación de contraseña en progreso
            </Typography>
            <Typography variant="body1" gutterBottom align="left">
            Se ha enviado un correo electrónico a la dirección ingresada con instrucciones para recuperar la contraseña.
            </Typography><br />
            <Link href="/jupiter" underline="hover">
              <Typography variant="body1" gutterBottom align="left">
                Iniciar sesión
              </Typography>
            </Link>
          </CardContent>
        </Card>
      </Box>
    );
  }

  return (
    <Box
      data-testid="envio-correo-recuperacion"
      sx={{
        width: { xs: "100%", lg: "50%" },
        minHeight: "100%",
        height: "100vh",
        flexGrow: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        paddingLeft: { xs: 0, md: 3 },
      }}
    >
      <Card
        variant="elevation"
        sx={{
          minWidth: { xs: "85%", md: "350px" },
          padding: { xs: 2, md: 3 },
          marginY: 3,
          marginX: { xs: 3, md: 0 },
        }}
      >
        <CardContent>
          <Typography
            variant="h5"
            component="div"
            gutterBottom
            align="left"
            color="primary"
            sx={{ fontWeight: "bold" }}
          >
            Recuperación de contraseña
            <br />
            <br />
          </Typography>
          <Formik
            initialValues={setValoresInicialesForm()}
            onSubmit={(values, { setSubmitting }) => {
              setSubmitting(true);
              onSubmit(values, setSubmitting);
            }}
            validationSchema={esquemaDeValidacionLogin}
          >
            {({ values, handleSubmit }) => (
              <Form onSubmit={handleSubmit} className="space-y-6">
                <TextInput
                  data-testid="input-correo"
                  label="E-mail/usuario"
                  name="nombreUsuarioCorreoDocumento"
                  type="text"
                  InputLabelProps={{ shrink: true }}
                />
                <br />
                <br />
                <Button
                  data-testid="btn-enviar-correo"
                  type="submit"
                  disabled={cargandoPeticion}
                  color="secondary"
                  variant="contained"
                  sx={{
                    width: "100%",
                    borderRadius: "10px",
                    padding: "10px",
                    color: "white",
                    "&:hover": {
                      transform: "translateY(-1px)",
                    },
                  }}
                >
                  Recuperar
                </Button>
              </Form>
            )}
          </Formik>
        </CardContent>
      </Card>
    </Box>
  );
}

export default EnvioCorreoRecuperacion;
